import { jsx as _jsx } from "react/jsx-runtime";
import { WPQTTabs } from "../../WPQTTabs";
import { LogsTabContent } from "./LogsTabContent";
import { CommentsTabContent } from "./PrivateCommentsTabContent";
import { PublicCommentsTabContent } from "./PublicCommentsTabContent";
function TaskModalTabs({ task }) {
    const tabs = ["Private comments", "Public comments", "Logs"];
    return (_jsx(WPQTTabs, { tabs: tabs, tabsContent: [
            _jsx(CommentsTabContent, { taskId: task.id }, 1),
            _jsx(PublicCommentsTabContent, { taskId: task.id }, 2),
            _jsx(LogsTabContent, { taskId: task.id }, 3),
        ] }));
}
export { TaskModalTabs };
